import { useEffect, useState } from "react";

// L2 · Шиммер-плейсхолдер. Универсальный, низкокалорийный, не отвлекает.
// Используется для KPI карточек, табличных строк, превью.
export function Shimmer({
  width,
  height = 14,
  rounded = 3,
  display = "inline-block",
}: {
  width?: number | string;
  height?: number;
  rounded?: number;
  display?: "inline-block" | "block";
}) {
  return (
    <span
      className="shimmer"
      style={{
        display,
        width: width ?? "100%",
        height,
        borderRadius: rounded,
      }}
    />
  );
}

// L1 · Цифровой тикер: пробегают случайные цифры в формате «XX,XX %».
// Передаёт ощущение «считаем», в отличие от пустого «—». Используется для
// Net YTM / Gross IRR на карточке бумаги во время холодного fetch'а.
// Шрифт/размер наследуется от родителя — кладите внутрь .kpi-num и т.п.
export function TickerNum({
  intLen = 2,
  precision = 2,
  suffix = " %",
}: {
  intLen?: number;
  precision?: number;
  suffix?: string;
}) {
  const total = intLen + precision;
  const [v, setV] = useState("");
  useEffect(() => {
    const id = setInterval(() => {
      let s = "";
      for (let i = 0; i < total; i++) s += Math.floor(Math.random() * 10);
      setV(s);
    }, 80);
    return () => clearInterval(id);
  }, [total]);
  const padded = v.padEnd(total, "0");
  return (
    <span style={{ opacity: 0.45 }}>
      {padded.slice(0, intLen)},{padded.slice(intLen)}
      {suffix}
    </span>
  );
}

// L3 · Bid/Ask тикер — две колеблющиеся котировки сходятся к цене.
// Семантика «ждём котировки от биржи». Используется для Bid/Offer строки.
export function BidAskTicker() {
  const [b, setB] = useState(98.7);
  const [a, setA] = useState(99.0);
  useEffect(() => {
    const id = setInterval(() => {
      setB(Number((98.6 + Math.random() * 0.3).toFixed(2)));
      setA(Number((99.0 + Math.random() * 0.2 - 0.1).toFixed(2)));
    }, 220);
    return () => clearInterval(id);
  }, []);
  return (
    <span className="row mono" style={{ gap: 6, alignItems: "baseline" }}>
      <span style={{ color: "var(--bad)", fontVariantNumeric: "tabular-nums" }}>
        {b.toFixed(2)}
      </span>
      <span className="soft">→</span>
      <span style={{ color: "var(--good)", fontVariantNumeric: "tabular-nums" }}>
        {a.toFixed(2)}
      </span>
    </span>
  );
}

// L4 · Pipeline-стадии: показываем что именно вычисляем сейчас. Хорошо
// подходит для долгого первого fetch'а скринера, чтобы пользователь видел
// «работа идёт», а не «ничего не происходит».
export function StagesProgress({ stages }: { stages: string[] }) {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setStep((s) => (s + 1) % stages.length), 700);
    return () => clearInterval(id);
  }, [stages.length]);
  return (
    <div className="stages-progress">
      {stages.map((s, i) => (
        <div key={i} className="stage">
          <div
            className="stage-bar"
            style={{ background: i <= step ? "var(--accent)" : "var(--line)" }}
          />
          <div
            className="stage-label"
            style={{ color: i === step ? "var(--accent)" : "var(--ink-soft)" }}
          >
            {s}
          </div>
        </div>
      ))}
    </div>
  );
}
